export const NEOBANK_ADDRESSES_QUERY_ID = 'NEOBANK_ADDRESSES_QUERY_ID'
export const NEOBANK_WALLETS_QUERY_ID = 'NEOBANK_WALLETS_QUERY_ID'
export const BANKING_PAYMENT_HISTORY_QUERY_ID =
  'BANKING_PAYMENT_HISTORY_QUERY_ID'
